import React from 'react';
import Button from './../../components/button';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Title, Micro } from '@vds/typography';
import { InHomeUtils } from '../../util/inhomeUtils';

export const CallMe = () => {
    function callMeNow(e){

    }
    return (
        <div>
            {/* <div className="modal_header" data-modal-header="">
                <h5 className="margin-top-zero">Talk to Verizon now!</h5>
            </div>
            <div className="modal_content fixModalHeight" data-modal-content=""> */}
            <ModalTitle>
                <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h5" color="black">Talk to Verizon now!</Title>                                        
             </ModalTitle>
             <ModalBody>
                <div data-reveal-speed="0" className="click-to-call-content" aria-hidden="false">
                    <p className="confirmation-msg">
                        Confirm the phone number where you would like Verizon to call you. We will call you momentarily to connect you to a live sales agent.<br />
                        <span style={{ color: 'red' }} aria-hidden="true" className="hide">
                            We're Sorry. There is problem with our click to call service. Please try again later.
                    </span>
                    </p>
                    <div className="column">
                        <label id="callPhone">Call me at </label>
                        <input id="Phone1" name="Phone1" type="tel" className="left w-phone-3" numbers="" pattern="\d{3}" maxLength="3" placeholder="000" title="Phone Number" move-next-on-maxlength="" tabIndex="100" aria-invalid="false" />
                        <input id="Phone2" name="Phone2" type="tel" className="left w-phone-3 margin-vert-micro" numbers="" pattern="\d{3}" maxLength="3" placeholder="000" title="Phone Number" move-next-on-maxlength="" tabIndex="101" aria-invalid="false" />
                        <input id="Phone3" name="Phone3" type="tel" className="left w-phone-3" numbers="" pattern="\d{4}" maxLength="4" placeholder="0000" title="Phone Number" move-next-on-maxlength="" tabIndex="102" aria-invalid="false" />
                    </div>
                    <div className="column">
                        <label id="callWhen">When</label>
                        <select className="w-medium value c2c-date-info" aria-invalid="false">
                        </select>
                    </div>
                    <div className="column" >
                        <label id="callTime">Time</label>
                        <select className="w-medium value" aria-invalid="false"><option value="" className="" defaultValue="select time">select time</option>
                        </select>
                    </div>
                    <div className="column">
                        <Button onClick={(e) => callMeNow(e)} buttonText="Call me now" buttonStyle={"button large-p-40 medium-p-35 small-p-50 tiny-p-100 small-margin-bottom-medium"} id="btnCallMe" disableButton={"disabled"} />
                    </div>
                </div>
                <div className="click-to-call-content hide" aria-hidden="true">
                    <span style={{ color: 'red' }} aria-hidden="true">
                        We're Sorry. There is problem with our click to call service. Please try again later.
                </span>
                    <div aria-hidden="true">
                        <div data-reveal-speed="0" aria-hidden="true">
                            We're calling you at () -. Please ensure your line is not busy.
                    </div>
                    </div>
                    <p>Your reference number is <b></b></p>
                </div>
            {/* </div> */}</ModalBody>
            <div className="modal_footer margin-bottom-zero padding-bottom-zero modal_footer small-padding-horiz-medium hide" aria-hidden="true">
                <div data-reveal-speed="0">
                    <a data-reveal-speed="0" className="button auto right" data-close-modal="" tabIndex="0" aria-label="Click here or press escape key to close the modal">Got it</a>
                </div>
            </div>
        </div>
    );
}

